export default "__VITE_ASSET__ejl5PYLn__"